// ReportsTable — sortable table of reports
import type { ReportItem } from "@/mocks/relatorios";
import ReportStatusBadge from "./ReportStatusBadge";
import ReportTypeBadge from "./ReportTypeBadge";

interface Props {
  reports: ReportItem[];
  onView: (r: ReportItem) => void;
}

export default function ReportsTable({ reports, onView }: Props) {
  if (reports.length === 0) return null;

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-background-200">
            <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Relatório</th>
            <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Tipo</th>
            <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Projeto</th>
            <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Município/UF</th>
            <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Período</th>
            <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Responsável</th>
            <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Formato</th>
            <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Status</th>
            <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Gerado em</th>
            <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Ações</th>
          </tr>
        </thead>
        <tbody>
          {reports.map((r) => (
            <tr key={r.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
              <td className="py-2.5 px-3">
                <div className="max-w-[220px]">
                  <div className="font-medium text-foreground-900 truncate">{r.title}</div>
                  <div className="text-xs text-foreground-400 truncate mt-0.5">{r.description}</div>
                </div>
              </td>
              <td className="py-2.5 px-3 whitespace-nowrap"><ReportTypeBadge type={r.type} /></td>
              <td className="py-2.5 px-3 text-foreground-600 whitespace-nowrap text-xs max-w-[140px] truncate">{r.projectName}</td>
              <td className="py-2.5 px-3 text-foreground-600 whitespace-nowrap text-xs">{r.municipality}/{r.uf}</td>
              <td className="py-2.5 px-3 text-foreground-600 whitespace-nowrap text-xs">{r.period}</td>
              <td className="py-2.5 px-3 text-foreground-600 whitespace-nowrap text-xs">{r.responsible}</td>
              <td className="py-2.5 px-3 whitespace-nowrap">
                <span className="text-xs font-medium text-accent-600 bg-accent-50 px-2 py-0.5 rounded">{r.format}</span>
              </td>
              <td className="py-2.5 px-3 whitespace-nowrap"><ReportStatusBadge status={r.status} /></td>
              <td className="py-2.5 px-3 text-foreground-500 whitespace-nowrap text-xs">{r.generatedAt || "—"}</td>
              <td className="py-2.5 px-3 whitespace-nowrap">
                <div className="flex items-center gap-1">
                  <button onClick={() => onView(r)} title="Visualizar" className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-primary-600 hover:bg-primary-50 transition-colors">
                    <i className="ri-eye-line w-4 h-4 flex items-center justify-center text-sm" />
                  </button>
                  <button title="Baixar PDF" className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-accent-600 hover:bg-accent-50 transition-colors">
                    <i className="ri-download-line w-4 h-4 flex items-center justify-center text-sm" />
                  </button>
                  <button title="Duplicar" className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-secondary-600 hover:bg-secondary-50 transition-colors">
                    <i className="ri-file-copy-line w-4 h-4 flex items-center justify-center text-sm" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}